export default {
    dependencies: ['window', 'bucketcookieservice'],
    callable(window, bucketCookie) {
        const screenString = `${window.screen.width}x${window.screen
            .height}x${window.devicePixelRatio || 1}`;
        bucketCookie.set('screenInfo', screenString);
    },
};



// WEBPACK FOOTER //
// ./controllers/screenCapabilities.js